import { Notification, Row, Text } from '@app/components'
import { metaMask, metaMaskHooks } from '@app/services'
import { useEffect, useState } from 'react'

import { MetamaskIcon } from '~public'

import { StyledWalletCard } from './elements'

const { useIsActivating } = metaMaskHooks

export const MetaCard: React.FC = () => {
  const isActivating = useIsActivating()
  const connector = metaMask
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [desiredChainId, setDesiredChainId] = useState<number>(-1)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState(undefined)
  // Might need these for further integration
  // const chainId = useChainId()
  // const accounts = useAccounts()
  // const isActive = useIsActive()
  // const ENSNames = useENSNames(provider)
  // attempt to connect eagerly on mount
  useEffect(() => {
    // void metaMask.connectEagerly().catch(() => {
    //   // eslint-disable-next-line no-console
    //   console.debug('Failed to connect eagerly to metamask')
    // })
  }, [])

  const handleOnClick = () => {
    if (isActivating) return

    connector
      .activate(desiredChainId === -1 ? undefined : desiredChainId)
      .then(() => {
        setError(undefined)
        Notification({ message: 'MetaMask connected successfully', type: 'success' })
      })
      .catch(setError)
  }

  return (
    <StyledWalletCard onClick={handleOnClick}>
      <Row justify="center">
        <MetamaskIcon />
      </Row>
      <Row justify="center">
        <Text>MetaMask</Text>
      </Row>
    </StyledWalletCard>
  )
}
